import Ca from "assets/ca.png";
// assets
import Arrow from "assets/icons/forward.svg";
import Check2 from "assets/icons/pop-check.svg";
import Cancel from "assets/icons/sm-x.svg";
import Back from "assets/svg/back-arrow.svg";
import Header from "components/dashHeader";
// components
import Sidemenu from "components/sidemenu";
import { debounce, round } from "lodash";
//css
import "pages/styles/dashboard/P2P.css";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { post } from "util/axiosLib";
import { logger } from "util/logger";
import { getExchangeRate } from "util/utils";




export default class P2PSellAd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popUpClicked: false,
      summaryClicked: false,
      errorBox: false,
      selectedCoin: "usdc",
      selectedSourceWallet: "ngn",
      quantity: 0.0,
      amount: 0.0,
      rate: 0,
      partialFilling: false,
      exchangeRate: 0,
      totalAmount: 0,
    };

    this.walletMap = {
      ngn: "Naira Wallet",
      ghs: "Ghana Cedis Wallet",
    };

    this.calculateValue = debounce(this.calculateValue, 1500);
  }

  async componentDidMount() {
    await this.handleCoinChange();
    const userData = JSON.parse(localStorage.getItem("btm_user"));
    //const userBankData = JSON.parse(localStorage.getItem("userBankData"));
    //logger(userData)
    this.setState({ 
      userCountry : userData.country
    })
  }

  calculateValue = async () => {
    const amount = round(
      this.state.exchangeRate *
        Number(this.state.quantity) *
        Number(this.state.rate),
      1
    );

    const totalAmount = round(
      this.state.exchangeRate * Number(this.state.rate)
    );

    logger("AMOUNT:: ", amount);
    this.setState({ amount, totalAmount });
  };

  // Handles change in coin selection dropdown
  handleCoinChange = async (event = "") => {
    const value = event?.target?.value || this.state.selectedCoin;
    this.setState({ selectedCoin: value });
    let coin = "";
    if (value === "teth") {
      coin = "eth";
    } else if (value === "tbtc") {
      coin = "btc";
    } else if (value === "ceur") {
      coin = "eur";
    } else if (value === "usdc") {
      coin = "usd";
    } else if (value === "usdt") {
      coin = "usd";
    } else if (value === "cusd") {
      coin = "usd";
    } else {
      coin = value;
    }

    const ticker = `${coin}usd`;
    let exchangeRate = 1;
    if (coin !== "usd") {
      exchangeRate = await getExchangeRate(ticker, "buy");
    }
    this.setState({ exchangeRate });

    if (this.state.quantity > 0 && this.state.rate > 0) {
      await this.calculateValue();
    }
    logger('EXCHANGE RATE"" ', exchangeRate);
  };

  handleSubmit = (event) => {
    event.preventDefault();

    this.setState({ summaryClicked: true });
  };

  // Handle all input changes
  handleInputChange = async (event) => {
    const target = event.target;
    const name = target.name;

    await this.setState({
      [name]: target.value,
    });

    const errmsg = document.getElementById("error-info2");
    errmsg.classList.remove("err-auth-on");
    this.setState({ incorrectError: " " });

    if (name === "quantity") {
      
      const numberRegex = /(?=[a-zA-Z])/;
       if(numberRegex.test(event.target.value) || event.target.value < 0){
         const errmsg = document.getElementById("error-info2");
         errmsg.classList.add("err-auth-on");
         this.setState({ incorrectError: "Please enter only valid numbers" });
       }

      if (this.state.quantity > 0) {
        const ebtn = document.getElementById("createBtn");
        await ebtn.classList.remove("e-disable");
      } else {
        const ebtn = document.getElementById("createBtn");
        await ebtn.classList.add("e-disable");
      }
      if (this.state.rate > 0) {
        await this.calculateValue();
      }
    } else if (name === "rate") {

      const numberRegex = /(?=[a-zA-Z])/;
       if(numberRegex.test(event.target.value) || event.target.value < 0){
         const errmsg = document.getElementById("error-info2");
         errmsg.classList.add("err-auth-on");
         this.setState({ incorrectError: "Please enter only valid numbers" });
       }

      if (this.state.quantity > 0) {
        await this.calculateValue();
      }
    } else if (name === "exact" || name === "minimum" || name === "maximum" || name === "amount" ) {
      const numberRegex = /(?=[a-zA-Z])/;
       if(numberRegex.test(event.target.value) || event.target.value < 0){
         const errmsg = document.getElementById("error-info2");
         errmsg.classList.add("err-auth-on");
         this.setState({ incorrectError: "Please enter only valid numbers" });
       }
   }
  };

  handleSourceWalletChange = (event) => {
    this.setState({ selectedSourceWallet: event.target.value });
  };

  handleToggle =  () => {
    const tBox = document.getElementById("toggle");
    
    if (tBox.checked === true){
       this.setState({ partialFilling: "true" })
    }  if (tBox.checked !== true){
      this.setState({ partialFilling: "false" })
    }

  }

  handleSummary = async (event) => {
    event.preventDefault();

    try {
      const reqBody = {
        volume: this.state.quantity,
        //coin: this.state.selectedCoin,
        sourceUnit: this.state.selectedCoin,
        destinationUnit: this.state.selectedSourceWallet,
        totalCost: this.state.amount,
        acceptPartialFilling: JSON.parse(this.state.partialFilling), 
        unitCost: this.state.rate, 

        minimumFilling: this.state.minimum, // optional
        maximumFilling: this.state.maximum, // optional
        exactFilling: this.state.exact, // optional

        country: this.state.userCountry,
        
      };

      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/p2p/listing/sell`;
      const token = localStorage.getItem("tokenset");
      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      const sellReq = await post(endpoint, reqBody, headers);
      logger(sellReq);
      logger(this.state.partialFilling);

      if (sellReq.data.status === "success") {
        this.setState({ summaryClicked: false });
        this.setState({ popUpClicked: true });
      } else {
      }
    } catch (err) {
      logger("login ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;
        logger(errData.data.error);
        this.setState({
          errorMessage: Object.values(errData.data.error),
          //summaryClicked: false,
          //errorBox: true,
        });
        const errmsg = document.getElementById("error-info");
        errmsg.classList.add("error-info-on");
      }
    }
  };

  render() {
    const currentPage = "P2P";

    return (
      <div>
        <Sidemenu currentPage={currentPage} />
        <Header />

        {this.state.popUpClicked ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__slideInDown">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                <h2>Sell Ad</h2>
                <p className="popup-success">Created Successfully!</p>
                <p
                  onClick={() => this.setState({ popUpClicked: false })}
                  className="popup-close"
                >
                  Close
                </p>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.errorBox ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__slideInDown">
                <div className="popup-img">
                  <img
                    className="sm-ca animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Ca}
                    alt=""
                  />
                </div>
                <h2 className="error-heading">
                  {/* {this.state.coinAmount}{" "}
                  {this.state.selectedCoin.toUpperCase()} */}
                  {this.state.errorMessage}
                </h2>
                <p className="popup-success"></p>
                <p
                  onClick={() => this.setState({ errorBox: false })}
                  className="popup-close"
                >
                  Close
                </p>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.summaryClicked ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box animate__animated animate__slideInUp">
                <div className="sc-top">
                  <h2 className="">Summary</h2>
                  <img
                    onClick={() => this.setState({ summaryClicked: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <div className="sc-items">
                  <p className="sc-item-title"> Coin </p>
                  <p className="bold">
                    {" "}
                    {this.state.selectedCoin.toUpperCase()}{" "}
                  </p>
                </div>
                <div className="sc-items">
                  <p className="sc-item-title"> Quantity </p>
                  <p className="bold">
                    {" "}
                    {this.state.quantity +
                      " " +
                      this.state.selectedCoin.toUpperCase()}{" "}
                  </p>
                </div>
                {this.state.partialFilling === "true" && (
                  <div className="sc-items">
                  <p className="sc-item-title"> Accept Partial Filling</p>
                  <p className="bold">
                    True
                  </p>
                </div>
                )}
                {this.state.rate !== 0 && (
                <div className="sc-items">
                  <p className="sc-item-title"> Rate(per $) </p>
                  <p className="bold">
                    {" "}
                    {this.state.rate}{" "}
                    {this.state.selectedSourceWallet.toUpperCase()}{" "}
                  </p>
                </div>)}
                
                
                <div className="sc-items">
                  <p className="sc-item-title"> Amount </p>
                  <p className="bold">
                    {" "}
                    {Number(this.state.amount).toLocaleString() +
                      " " +
                      this.state.selectedSourceWallet.toUpperCase()}{" "}
                  </p>
                </div>
                <div className="sc-items">
                  <p className="sc-item-title"> Fee</p>
                  <p className="bold">
                   0.08%
                  </p>
                </div>
                <div className="sc-items-last">
                  <p className="sc-item-title"> Payment Method</p>
                  <p className="bold">
                    {" "}
                    {this.walletMap[this.state.selectedSourceWallet]}{" "}
                  </p>
                </div>
                <button
                  onClick={this.handleSummary}
                  className="summaryclicked-btn"
                >
                  Submit
                </button>
                <div
                  id="error-info"
                  className="error-info animate__animated animate__fadeIn"
                >
                  <p>{this.state.errorMessage}</p>
                </div>
              </div>
            </section>
          </div>
        ) : null}

        <section className="p2p">
        <div
        id="error-info2"
        className="err-auth zindex animate__animated animate__slideInDown">
          <p>
              <strong>{this.state.incorrectError}</strong>
          </p>
        </div>
          <div className="p2p-container">
            <div className="p2p-content">
              <Link to="/dashboard/p2p">
                <img src={Back} className="w-backarrow" alt="back" />
              </Link>
              <h1> Create Sell Ad </h1>
              <div className="p2p-nav">
                <Link to="/dashboard/p2p" className="right-e">
                  <p className="ash"> P2P </p>{" "}
                </Link>
                <img className="right-e" src={Arrow} alt="" />
                <p>
                  <span className="bold"> Create Sell Ad </span>
                </p>
              </div>
              <div className="p2p-buyad-box">
                <form onSubmit={this.handleSubmit} className="buyad-form">
                  <div className="p2p-inputs">
                    <p>Coin</p>
                    <select
                      className="p2p-dropdown round"
                      onChange={this.handleCoinChange}
                      defaultValue={this.state.selectedCoin}
                      required
                    >
                      <option value={process.env.REACT_APP_COIN_A}>
                        {" "}
                        {process.env.REACT_APP_COIN_A.toUpperCase()}{" "}
                      </option>

                      <option value={process.env.REACT_APP_COIN_D}>
                        {" "}
                        {process.env.REACT_APP_COIN_D.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_F}>
                        {" "}
                        {process.env.REACT_APP_COIN_F.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_G}>
                        {" "}
                        {process.env.REACT_APP_COIN_G.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_H}>
                        {" "}
                        {process.env.REACT_APP_COIN_H.toUpperCase()}{" "}
                      </option>
                    </select>
                  </div>

                  <div className="p2p-inputs">
                    <p>Quantity you want to sell (Minimum listing 0.001)</p>
                    <input
                      type="text"
                      name="quantity"
                      onChange={this.handleInputChange}
                      placeholder={
                        this.state.quantity +
                        " " +
                        this.state.selectedCoin.toUpperCase()
                      }
                      required
                    />
                  </div>
                  <div className="p2p-inputs flex-sp">
                    <p className="right-m5">Accept Partial Filling</p>
                    <label className="switch-toggle">
                      <input onChange={this.handleToggle} type="checkbox" id="toggle" name="toggle" />
                      <span className="slider-toggle round"></span>
                    </label> 
                  </div>
                  {this.state.partialFilling === "true" && (
                    <div className="p2p-inputs animate__animated animate__fadeIn">
                    <p>Minimum Filling</p>
                    <input
                      type="text"
                      name="minimum"
                      onChange={this.handleInputChange}
                      placeholder={
                       "0.00 "+
                        this.state.selectedCoin.toUpperCase()
                      }
                      //required
                    />
                   </div>
                  )}
                  {this.state.partialFilling === "true" && (
                    <div className="p2p-inputs animate__animated animate__fadeIn">
                    <p>Maximum Filling</p>
                    <input
                      type="text"
                      name="maximum"
                      onChange={this.handleInputChange}
                      placeholder={
                       "0.00 "+
                        this.state.selectedCoin.toUpperCase()
                      }
                      //required
                    />
                   </div>
                  )}
                  {this.state.partialFilling === "true" && (
                    <div className="p2p-inputs animate__animated animate__fadeIn">
                    <p>Exact Filling</p>
                    <input
                      type="text"
                      name="exact"
                      onChange={this.handleInputChange}
                      placeholder={
                       "0.00 "+
                        this.state.selectedCoin.toUpperCase()
                      }
                      //required
                    />
                   </div>
                  )}
                  {this.state.partialFilling === "true" && (
                  <div className="p2p-inputs animate__animated animate__fadeIn">
                    <p>Rate</p>
                    <input
                      type="text"
                      name="rate"
                      onChange={this.handleInputChange}
                      placeholder="0.00"
                      required
                    />
                  </div>
                  )}
                  <div className="p2p-inputs txt-reduce">
                    <p>Total Amount (Based on Quantity)</p>
                    <input
                      type="text"
                      name="amount"
                      onChange={this.handleInputChange}
                      placeholder="0.00"
                      required
                      // value={
                      //   Number(this.state.amount).toLocaleString() +
                      //   " " +
                      //   this.state.selectedSourceWallet.toUpperCase()
                      // }
                     //disabled
                    />
                  </div>
                  {/* <div className="p2p-inputs txt-reduce">
                    <p>Price of {this.state.selectedCoin.toUpperCase()}</p>
                    <input
                      type="text"
                      name="totalAmount"
                      placeholder={
                        Number(this.state.totalAmount).toLocaleString() +
                        " " +
                        this.state.selectedSourceWallet.toUpperCase()
                      }
                      disabled
                    />
                  </div>
                  <div className="p2p-inputs">
                    <p>Payment Method</p>
                    <select
                      className="p2p-dropdown round"
                      onChange={this.handleSourceWalletChange}
                      defaultValue={this.state.selectedSourceWallet}
                      required
                    >
                      <option value={"ngn"}> Naira Wallet </option>
                      <option value={"ghs"}> Ghana Cedis Wallet </option>
                    </select>
                  </div> */}
                  <button id="createBtn" className="p2p-submit e-disable" type="submit">
                    {" "}
                    Create{" "}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
